import React from 'react'

/** Shown while a page's code chunk downloads. */
const PageFallback: React.FC = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
  </div>
)

export default PageFallback
